import React from "react"

export const SceneBridgeContext = React.createContext()

const SceneBridgeContainer = ({ value, children }) => {
  return <SceneBridgeContext.Provider value={{ ...value }}>{children}</SceneBridgeContext.Provider>
}

export default SceneBridgeContainer
